import { ReactNode } from "react";
import { ESupportedGames, TUserGroup, TTags, TUserRank } from "../../@types";
import { TFeaturedItemType } from "./Featured/@types";
import { IContentBadge } from "./ContentItemBadge";

export interface IContentItem {
  _id: string;
  thumbnailStandardUrl?: string;
  thumbnailOverlayUrl?: string;
  previewUrl?: string;
  createdAt?: string;
  clipImageThumb?: string;
  clipSnapshot?: string;
  clipLink?: string;
  clipPreviewPath?: string;
  clipTitle?: string;
  clipId?: string;
  createdDate?: string;
  external?: boolean;
  game?: number | string;
  hlsSrc?: string;
  hasBeenPinned?: boolean;
  shareId: string;
  title?: string;
  username?: string;
  type?: TFeaturedItemType;
  views: number;
  score?: number | { value: number };
  userClipTitle?: string;
  badge?: IContentBadge;
  reason?: string;
  user: {
    _id: string;
    username: string;
    avatar?: string;
    userGroup?: {
      type: TUserGroup;
    };
    rank?: TUserRank;
  };
  tags?: TTags[];
  playerGameIdentifier?: string;
}

export interface IEmptyContentItem extends IContentItem {
  icon?: ReactNode;
  text?: string;
}

export enum ESuggestedFollowReason {
  PLAYED_TOGETHER = "Played Together",
  STEAM_FRIEND = "Steam Friend",
  COMMON_FOLLOWER = "Common Follower",
  FRIEND_OF_FRIEND = "Friend of a Friend",
  EXTENDED_NETWORK = "Extended Network",
  FOLLOW_BACK = "Follow Back",
  POPULAR_USER = "Popular User",
  UNSPECIFIED = "Unspecified",
}

export interface ISuggestedFollow {
  user: ISuggestedFollower;
  reason: ESuggestedFollowReason;
  score: number;
}
export interface ISuggestedFollower {
  _id: string;
  avatar: string;
  avatarUrl: string;
  followingCount: number;
  reason?: string;
  username: string;
  rank?: TUserRank;
  userGroup?: {
    type: TUserGroup;
  };
  discord: {
    id: string;
  };
  steam: {
    steamid?: string;
    personaname?: string;
  };
}

export interface ISuggestedUser {
  user: {
    _id: string;
    avatar: string;
    username: string;
    userGroup?: {
      type: TUserGroup;
    };
  };
  lastPlayedAt: string;
  followedBy: [
    {
      username: string;
      avatar: string;
    },
  ];
  playedGameId: ESupportedGames;
  reason:
    | "PLAYED_TOGETHER"
    | "FOLLOWED_BY_FOLLOWING"
    | "RISING_STAR"
    | "UNSPECIFIED";
}
